import { Log, UserManager } from 'oidc-client-ts';
import { trace } from '../setup/trace';
import { routeStorage } from './storage';

/**
 * Handles OIDC redirect callbacks for both the main app window and silent-renew iframes.
 *
 * @returns True when bootstrapping should continue. Silent-renew iframe callbacks return false
 * because they only notify the parent window and must not start login again.
 */
export const handleLoginRedirect = async (userManager: UserManager): Promise<boolean> => {
    const runsInIframe = window?.parent && window.parent !== window;

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        // This will propagate the received information provided via
        // query parameters to the parent frame
        trace('signinRedirect via the iframe');
        const user = await userManager.signinCallback();
        return user !== undefined;
    } else {
        trace('signinRedirect via parent window');
        await userManager
            .signinRedirectCallback()
            .catch(trace)
            .then(() => {
                redirectToLastRouteOrHome();
            });
        return true;
    }
};

export const redirectToLastRouteOrHome = () => {
    const initialRoute = routeStorage.getRoute() ? routeStorage.getRoute() : '';
    const redirectPath = initialRoute?.startsWith('?') ? initialRoute : `/#/${initialRoute}`;
    window.history.replaceState(null, '', `${window.location.origin}${redirectPath}`);
};
